import { Typography } from '../../designComponents';
import Timeline from '../../designComponents/Timeline';
import { VerticalSpaceStyled } from '../../style/reusableStyle';
import { JobDetailsContainerStyled } from './style';

type Props = {
  events?: {
    date: string;
    title: string;
    description?: string;
  }[];
};

const ProposalDetail = ({ events = [] }: Props) => {
  return (
    <JobDetailsContainerStyled>
      <Typography
        variant="normal"
        className="title"
        fontColor="secondary"
        strong
      >
        PROPOSAL DETAILS
      </Typography>
      <VerticalSpaceStyled>
        <Timeline events={events} />
      </VerticalSpaceStyled>
    </JobDetailsContainerStyled>
  );
};

export default ProposalDetail;
